import { i18n } from '../helpers/i18n';
import { t } from '@lingui/macro';

export const ERROR_DATE = {
  IS_IN_FUTURE: i18n._(t`Дата из будущего`),
  IS_IN_PAST: i18n._(t`Дата из прошлого`),
  DOCUMENT_TOO_OLD: i18n._(t`Проверьте дату выдачи документа. Паспортов РФ с датой выдачи раньше 1 октября 1997 года не существует.
`),
  PASSPORT_IS_EXPIRED: i18n._(t`Срок действия паспорта закончился.`),
  DOCUMENT_DATE_EARLY_THAN_14: i18n._(
    t`Дата выдачи паспорта не может быть раньше даты наступления возраста 14 лет`
  ),
  BIRTHDATE_EARLY_PATERNITY_DATE: i18n._(
    t`Дата регистрации отцовства не может быть раньше даты рождения ребёнка`
  ),
  BIRTHDATE_EARLY_MARRIAGE_DATE: i18n._(
    t`Дата заключения брака не может быть раньше даты рождения супругов`
  ),

  DEATHDATE_EARLY_BIRTHDATE: i18n._(
    t`Дата смерти не может быть раньше даты рождения`
  ),
  DOCUMENT_DATE_EARLY_BIRTHDATE: i18n._(
    t`Дата выдачи не может быть раньше даты рождения`
  ),
  DIVORCE_DATE_EARLY_MARRIAGE: i18n._(
    t`Дата расторжения брака не может быть раньше даты заключения`
  ),
  MARRIAGE_DATE_EARLY_APPLICANT_BIRTHDATE: i18n._(
    t`Дата заключения брака не может быть раньше даты рождения заявителя`
  ),
};

export const setErrorField = (error) => ({
  error,
});
